import { Injectable } from '@angular/core';
import versionInfo from '@/src/git-version.json';

@Injectable({providedIn: 'root'})
export class VersionService {

    getVersion(): string {  
        return `${versionInfo.version} - ${versionInfo.hash}`;
    }

  
}